import { PermissionsEnum } from "@mindlercare/schema";
import { Navigate, Outlet } from "react-router-dom";
import { hasPermissions } from "../helpers/permissions";
import { useCurrentUser } from "../hooks/userHooks";

export const RequiresPermissions: React.FC<{
  permissions: PermissionsEnum | PermissionsEnum[];
  children?: React.ReactNode;
}> = ({ children, permissions }) => {
  const { user, isLoading } = useCurrentUser();
  if (isLoading) return null;
  if (!hasPermissions(user, permissions)) {
    return <Navigate to="/" replace />;
  }

  return <>{children ?? <Outlet />}</>;
};
